(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pareeza-review-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pareeza-reviews')) {
    class PareezaReviews extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        this.viewport = this.querySelector('[data-viewport]');
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        this.previousButton = this.querySelector('[data-previous]');
        this.nextButton = this.querySelector('[data-next]');
        this.dotsContainer = this.querySelector('[data-dots]');
        this.status = this.querySelector('[data-status]');
        this.currentIndex = 0;
        this.startX = 0;
        this.touching = false;
        this.isVisible = false;
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

        if (!this.track || !this.viewport || !this.slides.length) return;

        this.abortController = new AbortController();
        const signal = this.abortController.signal;

        this.previousButton?.addEventListener('click', () => {
          this.previous();
          this.restartAutoplay();
        }, { signal });

        this.nextButton?.addEventListener('click', () => {
          this.next();
          this.restartAutoplay();
        }, { signal });

        this.addEventListener('mouseenter', () => this.stopAutoplay(), { signal });
        this.addEventListener('mouseleave', () => this.startAutoplay(), { signal });
        this.addEventListener('focusin', () => this.stopAutoplay(), { signal });
        this.addEventListener('focusout', () => this.startAutoplay(), { signal });

        this.track.addEventListener('touchstart', (event) => {
          this.startX = event.touches[0].clientX;
          this.touching = true;
          this.stopAutoplay();
        }, { passive: true, signal });

        this.track.addEventListener('touchmove', (event) => {
          if (!this.touching) return;
          const difference = event.touches[0].clientX - this.startX;
          if (Math.abs(difference) < 50) return;
          this.touching = false;
          difference < 0 ? this.next() : this.previous();
        }, { passive: true, signal });

        this.track.addEventListener('touchend', () => {
          this.touching = false;
          this.startAutoplay();
        }, { passive: true, signal });

        document.addEventListener('visibilitychange', () => {
          document.hidden ? this.stopAutoplay() : this.startAutoplay();
        }, { signal });

        this.resizeObserver = new ResizeObserver(() => {
          window.requestAnimationFrame(() => {
            this.currentIndex = Math.min(this.currentIndex, this.maxIndex());
            this.buildDots();
            this.update(false);
          });
        });
        this.resizeObserver.observe(this.viewport);

        this.intersectionObserver = new IntersectionObserver((entries) => {
          this.isVisible = entries[0].isIntersecting;
          this.isVisible ? this.startAutoplay() : this.stopAutoplay();
        }, { threshold: 0.2 });
        this.intersectionObserver.observe(this);

        this.buildDots();
        this.update(false);
      }

      disconnectedCallback() {
        this.stopAutoplay();
        this.abortController?.abort();
        this.resizeObserver?.disconnect();
        this.intersectionObserver?.disconnect();
      }

      visibleSlides() {
        if (window.innerWidth <= 600) return 1;
        if (window.innerWidth <= 991) return 2;
        return 3;
      }

      maxIndex() {
        return Math.max(0, this.slides.length - this.visibleSlides());
      }

      slideDistance() {
        const gap = parseFloat(window.getComputedStyle(this.track).columnGap) || 0;
        return this.slides[0].getBoundingClientRect().width + gap;
      }

      buildDots() {
        const count = this.maxIndex() + 1;
        this.dotsContainer.replaceChildren();

        for (let index = 0; index < count; index += 1) {
          const dot = document.createElement('button');
          dot.className = 'pareeza-reviews__dot';
          dot.type = 'button';
          dot.setAttribute('aria-label', `Go to review ${index + 1}`);
          dot.addEventListener('click', () => {
            this.currentIndex = index;
            this.update();
            this.restartAutoplay();
          }, { signal: this.abortController.signal });
          this.dotsContainer.appendChild(dot);
        }
      }

      update(announce = true) {
        this.currentIndex = Math.min(Math.max(this.currentIndex, 0), this.maxIndex());
        const distance = this.currentIndex * this.slideDistance();
        this.track.style.transform = `translate3d(-${distance}px, 0, 0)`;

        Array.from(this.dotsContainer.children).forEach((dot, index) => {
          dot.setAttribute('aria-current', index === this.currentIndex ? 'true' : 'false');
        });

        const hasMultiplePages = this.maxIndex() > 0;
        this.previousButton.disabled = !hasMultiplePages;
        this.nextButton.disabled = !hasMultiplePages;
        this.dotsContainer.hidden = !hasMultiplePages;

        if (announce && this.status) {
          this.status.textContent = `Showing review ${this.currentIndex + 1} of ${this.slides.length}`;
        }
      }

      next() {
        this.currentIndex = this.currentIndex >= this.maxIndex() ? 0 : this.currentIndex + 1;
        this.update();
      }

      previous() {
        this.currentIndex = this.currentIndex <= 0 ? this.maxIndex() : this.currentIndex - 1;
        this.update();
      }

      startAutoplay() {
        const enabled = this.dataset.autoplay === 'true';
        if (!enabled || !this.isVisible || document.hidden || this.reducedMotion.matches || this.maxIndex() === 0) return;
        if (this.autoplayTimer) return;
        const speed = Number(this.dataset.autoplaySpeed) || 4000;
        this.autoplayTimer = window.setInterval(() => this.next(), speed);
      }

      stopAutoplay() {
        window.clearInterval(this.autoplayTimer);
        this.autoplayTimer = null;
      }

      restartAutoplay() {
        this.stopAutoplay();
        this.startAutoplay();
      }
    }

    customElements.define('pareeza-reviews', PareezaReviews);
  }

  } catch(e) { console.error(e); }
})();
})();
